<!-- DbPasswordInput.vue -->
<template>
  <div class="relative w-full">
    <db-input
      :type="showPassword ? 'text' : 'password'"
      :variant="variant"
      :placeholder="placeholder"
      :label="label"
      :name="name"
      :model-value="modelValue"
      @update:modelValue="updateValue"
      @on-key:enter="$emit('onEnter')"
      @input="handleInput"
      :ariainvalid="ariainvalid"
    />
    <span
      class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer select-none"
      @click="togglePasswordVisibility"
    >
      <svg
        v-if="!showPassword"
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-gray-600"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        />
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.683 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        />
      </svg>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-gray-600"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a10.09 10.09 0 01-1.683 2.947M3 3l18 18"
        />
      </svg>
    </span>
  </div>
</template>

<script setup>
import { ref } from "vue";
import DbInput from "@/components/DB-Components/DbInput.vue";

const props = defineProps({
  modelValue: { type: String, required: true },
  placeholder: { type: String, default: "" },
  label: { type: String, default: "" },
  class: { type: String, default: "" },
  variant: { type: String, default: "white" },
  name: { type: String, default: "" },
  ariainvalid: { type: String, default: null },
});

const emit = defineEmits(["update:modelValue", "onEnter", "input"]);

const showPassword = ref(false);

const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value;
};

const updateValue = (value) => emit("update:modelValue", value);
const handleInput = (event) => emit("input", event);
</script>
